var _BRAND_NAMES, _URL_FOR_BRAND;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { availableTypes, caviarIcons, currentIconSubdirectoryName, doordashIcons } from './availableIcons';
import { createIconColors } from './utils';
export var IconSizes = {
  Tiny: 12,
  Small: 16,
  Medium: 24,
  Large: 32,
  XLarge: 48,
  XxLarge: 64,
  XxxLarge: 96,
  Huge: 128
};
export var IconBrands = {
  Caviar: 'BRAND_CAVIAR',
  DoorDash: 'BRAND_DOORDASH'
};
export var IconColors = createIconColors();
export var IconTypes = availableTypes.DoorDash;
export var BRAND_NAMES = (_BRAND_NAMES = {}, _defineProperty(_BRAND_NAMES, IconBrands.Caviar, 'Caviar'), _defineProperty(_BRAND_NAMES, IconBrands.DoorDash, 'DoorDash'), _defineProperty(_BRAND_NAMES, "Caviar", 'Caviar'), _defineProperty(_BRAND_NAMES, "DoorDash", 'DoorDash'), _BRAND_NAMES);
export var DEFAULT_BRAND = BRAND_NAMES.DoorDash;
export var URL_FOR_BRAND = (_URL_FOR_BRAND = {}, _defineProperty(_URL_FOR_BRAND, BRAND_NAMES.Caviar, 'caviar/'), _defineProperty(_URL_FOR_BRAND, BRAND_NAMES.DoorDash, 'default/'), _URL_FOR_BRAND);
export var svgSourceBaseUrl = "https://s3-design-language-system.cdn4dd.com/icons/".concat(currentIconSubdirectoryName, "/");
export var availableBrandTypes = {
  Caviar: availableTypes.Caviar,
  DoorDash: availableTypes.DoorDash
};
export var availableIcons = {
  Caviar: caviarIcons,
  DoorDash: doordashIcons
};